export const isLeaveSite = (url: string) => {
  // Check if window is defined (so if in the browser or in node.js).
  const isBrowser = typeof window !== "undefined"
  if (!isBrowser) return false
  if (url.startsWith("//")) {
    return !url.includes(window.location.host)
  }
  return url.startsWith("/") ? false : !url.includes(window.location.origin)
}
